<template>
  <div class="sidebar-container" :class="{ collapsed: collapsed }">
    <!-- Logo -->
    <div class="logo">
      <el-icon v-if="!collapsed" class="logo-icon"><Platform /></el-icon>
      <span v-if="!collapsed">平台后台</span>
      <el-icon v-else class="logo-icon"><Platform /></el-icon>
    </div>
    
    <!-- 菜单 -->
    <el-menu
      :default-active="activeMenu"
      :collapse="collapsed"
      :collapse-transition="false"
      router
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <template v-for="route in menuList" :key="route.path">
        <el-menu-item v-if="!route.hidden && !route.children" :index="route.path">
          <el-icon>
            <component :is="route.meta.icon" />
          </el-icon>
          <template #title>{{ route.meta.title }}</template>
        </el-menu-item>

        <el-sub-menu v-else-if="!route.hidden" :index="route.path">
          <template #title>
            <el-icon>
              <component :is="route.meta.icon" />
            </el-icon>
            <span>{{ route.meta.title }}</span>
          </template>

          <el-menu-item
            v-for="child in route.children"
            :key="child.path"
            :index="child.path"
          >
            {{ child.meta.title }}
          </el-menu-item>
        </el-sub-menu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { menuList } from '@/router'

export default {
  name: 'Sidebar',
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const route = useRoute()

    const activeMenu = computed(() => {
      return route.path
    })
    
    return {
      menuList,
      activeMenu
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-container {
  width: 220px;
  height: 100%;
  background-color: #304156;
  transition: width 0.3s;
  
  &.collapsed {
    width: 64px;
  }
  
  .logo {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    border-bottom: 1px solid #1f2d3d;
    
    .logo-icon {
      font-size: 28px;
      color: #409EFF;
      margin-right: 10px;
    }
    
    span {
      font-size: 18px;
      font-weight: 600;
    }
  }
  
  .el-menu {
    border-right: none;
    
    .el-menu-item,
    .el-sub-menu__title {
      height: 50px;
      line-height: 50px;
    }
  }
}
</style>
